import {observable} from 'mobx';
import {RECORDING_STATUS} from '@techsee/techsee-common/lib/constants/room.constants';
import {WifiScanStatusType, VisualScanStatusType} from '@techsee/techsee-common/lib/constants/utils.constant';

export class DashboardRoomStorage {
    @observable audioSupport?: boolean = undefined;
    @observable audioHandshakeSuccess: boolean = false;
    @observable audioMuted: boolean = false;
    @observable observersAudioMuted: any[] = [];
    @observable recordingStatus?: RECORDING_STATUS = undefined;
    @observable wifiScanStatus = WifiScanStatusType.NotInitialized;
    @observable visualScanStatus = VisualScanStatusType.NotInitialized;
}
